<template>
    <div class="sa-list-component">
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <template>
                    <b-table sticky-header ref="table" stacked="xl" striped hover :items="getRigheDocumento"
                        :fields="getFieldVisibile" :current-page="1" :per-page="perPage" sort-icon-left
                        head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            {{ (currentPage - 1) * perPage + row.index + 1 }}
                        </template>
                        <template #cell(codiceArticolo)="row">
                            <span style="font-weight: 600" v-if="row.index !== getRigheDocumento.length - 1">{{
                                row.item.codiceArticolo }}</span>
                        </template>
                        <template #cell(descrizione)="row">
                            <span style="font-weight: 600" v-if="row.index !== getRigheDocumento.length - 1">{{
                                row.item.descrizione }}</span>
                        </template>

                        <template #cell(descrizioneUm)="row">
                            <span style="font-weight: 600" v-if="row.index !== getRigheDocumento.length - 1">{{
                                row.item.umDescrizione }}</span>
                        </template>
                        <template #cell(quantita)="row">
                            <span style="font-weight: 600" v-if="row.index !== getRigheDocumento.length - 1">{{
                                row.item.quantita }}</span>
                        </template>
                        <template #cell(documentoRiferimentoRigaQuantita)="row">
                            <editable-cell v-if="row.index !== getRigheDocumento.length - 1" type="number"
                                :value="row.item.documentoRiferimentoRigaQuantita ? row.item.documentoRiferimentoRigaQuantita : 0"
                                @update="onUpdateQuantita(row, $event)" />
                        </template>
                        <template #cell(actions)="row">
                            <b-container class="bv-example-row">
                                <!-- :disabled="(jsonData.causaleDocumentoOperazioneMagazzino == -1 && jsonData.magazzinoId == null) || jsonData.causaleDocumentoOperazioneMagazzino == null" -->
                                <b-button
                                    v-if="row.index == getRigheDocumento.length - 1 && jsonData.documentiCollegati ? jsonData.documentiCollegati.length == 0 : false"
                                    :disabled="isBtnPlusDisabled(row)" size="sm"
                                    variant="btn btn-outline-success waves-effect waves-light width-sm no-text"
                                    @click="onAddRigaDocumento(row)">
                                    <b-icon icon="plus"></b-icon>
                                </b-button>
                                <b-button
                                    v-if="row.index != getRigheDocumento.length - 1 && row.item.documentoRiferimentoDescrizione == null"
                                    size="sm"
                                    variant="btn btn-outline-secondary waves-effect waves-light width-sm no-text"
                                    @click="onModificaRigaDocumento(row)">
                                    <b-icon icon="pencil"></b-icon>
                                </b-button>
                                <b-button
                                    v-if="row.index != getRigheDocumento.length - 1 && row.item.lottiScadenze.length > 0 && row.item.documentoRiferimentoDescrizione == null"
                                    size="sm" variant="btn btn-outline-info waves-effect waves-light width-sm no-text"
                                    @click="onClickInfoMatricolaLotto(row)">
                                    <b-icon icon="info"></b-icon>
                                </b-button>
                                <b-button v-if="row.index != getRigheDocumento.length - 1" size="sm"
                                    variant="btn btn-outline-danger waves-effect waves-light width-sm no-text"
                                    @click="onEliminaRigaDocumento(row)">
                                    <b-icon icon="trash"></b-icon>
                                </b-button>
                            </b-container>
                        </template>
                        <template #row-details="row">
                            <template v-if="row || row.item.lottiScadenze.length > 0">
                                <div class="sa-badge-group-lotti">
                                    <div class="sa-badge" v-for="(rigalotto, index) of row.item.lottiScadenze"
                                        :key="index">
                                        <span class="sa-badge-label">Codice:</span>
                                        <span class="sa-badge-data">{{ rigalotto.codiceArticolo }}</span>
                                        <span class="sa-badge-label">Lotto:</span>
                                        <span class="sa-badge-data">{{ rigalotto.lottoMatricola }}</span>
                                        <span class="sa-badge-label">Quantità:</span>
                                        <span class="sa-badge-data">{{ rigalotto.quantita }}</span>
                                        <span class="sa-badge-label">Data Scadenza:</span>
                                        <span class="sa-badge-data">{{ formatDate(rigalotto.dataOraScadenza) }}</span>
                                        <span class="sa-badge-label">Data Produzione:</span>
                                        <span class="sa-badge-data">{{ formatDate(rigalotto.dataOraProduzione) }}</span>
                                    </div>
                                </div>
                            </template>
                        </template>
                    </b-table>
                </template>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <contabilita-documento-riga-documento-modal-component
                ref="cmpContabilitaDocumentoRigaDocumentoModalComponent"
                @modificaRigaDocumento="onModificaRigaDocumentoComponent"
                @addQuantitaRigaDocumentoPresente="onAddQuantitaRigaDocumentoPresente"
                :righeDocumento="getRigheDocumento" @addRigaDocumento="onAggiungiRigaDocumento"
                :idMagazzino="jsonData.magazzinoId" :codiceStruttura="jsonData.strutturaCodice"
                :operazioneMagazzino="operazioneMagazzino" />
        </div>
    </div>
</template>

<script>
import ContabilitaDocumentoRigaDocumentoModalComponent from "./ContabilitaDocumentoRigaDocumentoModalComponent.vue";
import ContabilitaMixin from "../mixins/ContabilitaMixin";
import MagazzinoMixins from "../../magazzino/mixins/MagazzinoMixins";
import UtilityMixin from "../../utility/UtilityMixin";
import EditableCell from "../../utility/components/EditableCell.vue";
export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    mixins: [ContabilitaMixin, MagazzinoMixins, UtilityMixin],
    // EditableCell
    components: { ContabilitaDocumentoRigaDocumentoModalComponent, EditableCell },
    props: {
        jsonData: {
            type: Object,
            required: true,
            default: () => {
                return {};
            },
        },
    },
    computed: {
        getRigheDocumento() {
            return [...this.righeDocumento, {}];
        },
        getFieldVisibile() {
            let fields = this.fieldsRigheDocumento;
            if (this.jsonData.documentiCollegati) {
                if (this.jsonData.documentiCollegati.length == 0) {
                    fields = fields.filter((e) => e.key != "documentoRiferimentoRigaQuantita");
                } else {
                    let field = fields.filter((e) => e.key == "quantita");
                    field[0].label = "Qtn. Fatturabile";
                }
            }
            return fields;
        },
    },
    data() {
        return {
            operazioneMagazzino: null,
            currentPage: 1,
            rows: 0,
            perPage: 100,
            rigaDocumentoRiferimento: null,
            righeDocumento: [],
            isScaricoOperazione: false,
            rowRigaDocumentoSelezionataIndex: null,
            fieldsRigheDocumento: [
                {
                    label: "N.",
                    key: "index",
                    thStyle: "width: 3rem",
                },
                {
                    label: "Codice",
                    key: "codiceArticolo",
                    sortable: false,
                    thStyle: "width: rem",
                },
                {
                    label: "Descrizione",
                    key: "descrizione",
                    sortable: false,
                },
                {
                    label: "Qnt. da Fatturare",
                    key: "documentoRiferimentoRigaQuantita",
                    sortable: false,
                },
                {
                    label: "Qnt. Riga",
                    key: "quantita",
                    sortable: false,
                    thStyle: "width: 3rem",
                },
                {
                    label: "U.M.",
                    key: "descrizioneUm",
                    sortable: false,
                    thStyle: "width: 3rem",
                },
                {
                    label: "Pr. Unitario",
                    key: "prezzoUnitario",
                    sortable: true,
                    thStyle: "width: 7rem",
                    formatter: function (value) {
                        if (value) {
                            value = value.toLocaleString("it-IT", { style: "currency", currency: "EUR" });
                        } else if (value === 0) {
                            value = value.toLocaleString("it-IT", { style: "currency", currency: "EUR" });
                        }
                        return value;
                    },
                },
                {
                    label: "Sconto",
                    key: "sconto",
                    sortable: false,
                    thStyle: "width: 3rem",
                    formatter: function (value) {
                        if (value) {
                            value = value.toLocaleString("it-IT", { style: "percent" });
                        } else if (value === 0) {
                            value = value.toLocaleString("it-IT", { style: "percent" });
                        }
                        if (value > 0 && value <= 1) {
                            value = value * 100;
                            value = value.toLocaleString("it-IT", { style: "percent" });
                        }

                        return value;
                    },
                },
                {
                    label: "Tot. Riga",
                    key: "totaleRiga",
                    sortable: true,
                    thStyle: "width: 7rem",
                    formatter: function (value) {
                        if (value) {
                            value = value.toLocaleString("it-IT", { style: "currency", currency: "EUR" });
                        } else if (value === 0) {
                            value = value.toLocaleString("it-IT", { style: "currency", currency: "EUR" });
                        }
                        return value;
                    },
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
            matricoleFields: [
                {
                    key: "codiceArticolo",
                    label: "Codice Articolo",
                },
                {
                    key: "matricola",
                    label: "Matricola",
                },
                {
                    key: "actions",
                    label: "",
                },
            ],
            lottiFields: [
                {
                    key: "codiceArticolo",
                    label: "Articolo",
                },
                {
                    key: "lottoMatricola",
                    label: "Lotto",
                },
                {
                    key: "dataOraScadenza",
                    label: "Data Scadenza",
                },
                {
                    key: "dataOraProduzione",
                    label: "Data Produzione",
                },
                {
                    key: "actions",
                    label: "",
                },
            ],
        };
    },
    mounted() { },
    watch: {
        "jsonData.causaleDocumentoOperazioneMagazzino": function (params) {
            this.operazioneMagazzino = params;
        },
    },
    methods: {
        init(jsonData) {
            this.righeDocumento = jsonData.righeDocumento;
        },
        isBtnPlusDisabled() {
            if (!this.jsonData.causaleCodice) {
                return true;
            } else if (!this.jsonData.magazzinoId) {
                return true;
            }
        },
        onUpdateQuantita(row, valore) {
            let quantita = this.jsonData.righeDocumento[row.index].quantita;
            if (valore > quantita) {
                this.jsonData.righeDocumento[row.index].documentoRiferimentoRigaQuantita = new Number(quantita);
                this.$bvToast.toast(`Quantita da Fattura '${valore}' maggiore rispetto alla quantita riga riferimento '${quantita}' imposta di defualt al massimo della quantita disponibile`, {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
            } else {
                this.jsonData.righeDocumento[row.index].documentoRiferimentoRigaQuantita = new Number(valore);
            }
        },
        onAddRigaDocumento() {
            this.$refs.cmpContabilitaDocumentoRigaDocumentoModalComponent.onClickAddRiga(this.jsonData);
        },
        onModificaRigaDocumento(row) {
            this.$refs.cmpContabilitaDocumentoRigaDocumentoModalComponent.onModificaRigaDocumento(row);
        },
        onModificaRigaDocumentoComponent(index, item) {
            this.righeDocumento.splice(index, 1, item);
            this.$emit("update", this.righeDocumento);
        },

        onAggiungiRigaDocumento(riga) {
            this.righeDocumento.push(JSON.parse(JSON.stringify(riga)));
            this.$emit("update", this.righeDocumento);
        },
        onAddQuantitaRigaDocumentoPresente(riga) {
            if (riga) {
                let result = this.righeDocumento.filter((e) => e.codiceArticolo == riga.codiceArticolo && e.descrizione == riga.descrizione);
                if (result.length > 0) {
                    let rigaDoc = result[0];
                    rigaDoc.quantita++;
                    this.$emit("update", this.righeDocumento);
                }
            }
        },
        onClickInfoMatricolaLotto(row) {
            this.rowRigaDocumentoSelezionataIndex = row.index;
            row.toggleDetails();
        },

        onEliminaRigaDocumento(row) {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Sei sicuro di eliminare questa riga ?", {
                    title: "Eliminazione Riga Documento",
                    buttonSize: "sm",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    okVariant: "danger",
                    cancelVariant: "secondary",
                    hideHeaderClose: true,
                    footerClass: "p-2",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteRigaDocumento(row);
                    }
                })
                .catch((err) => {
                    err;
                });
        },
        deleteRigaDocumento(row) {
            let me = this;
            me.righeDocumento.splice(row.index, 1);
            this.$emit("update", this.righeDocumento);
        },
    },
};
</script>

<style scoped>
.sa-badge-group-lotti {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    margin-top: 15px;
}
</style>
